
import Footer from '../../components/feature/Footer';
import Header from '../../components/feature/Header';
import PrivacySection from './components/PrivacySection';




function Privacy() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <PrivacySection />
      </main>
      <Footer />
    </div>
  );
}

export default Privacy;